import { ListarProjetos } from "@/repositorios/projeto/projeto.modelo"
import { ListarControlador } from "@/repositorios/travamento/travamento.modelo"
import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"

export interface ItemDeProjetoComPeriodoTravado {
  idProjeto: string
  nome: string
  primeiroDiaDestravado: Date
  primeiroDiaDestravadoOriginal: Date
  editado: boolean
}

const { aplicarTimeZoneNaDataHora } = usarDataHora()

export const estruturarDadosDeProjetosParaEdicaoNaTabela = (
  controladores: ListarControlador[],
  projetos: ListarProjetos[]
) => {
  const mapearNomesDeProjetosPorId = () => {
    const nomesDeProjetoPorId = new Map()
    projetos.forEach((projeto) => {
      nomesDeProjetoPorId.set(projeto.id, projeto.nomeProjeto)
    })
    return nomesDeProjetoPorId
  }

  const mapearListaDeDatasIniciaisPorProjetoId = () => {
    const listaDeDatasFinaisPorProjetoId = controladores.reduce(
      (acumulador, controlador) => {
        const periodosNaoTravados =
          controlador.periodos.filter((periodo) => periodo.travado === false)
        const listaDeDatasIniciaisDosPeriodos =
          periodosNaoTravados.map(
            (periodo) => periodo.dataInicial
          )
        const listaDeDatasIniciaisPreviamenteAcumuladas =
          acumulador[controlador.projetoId] || []
        acumulador[controlador.projetoId] = [
          ...listaDeDatasIniciaisPreviamenteAcumuladas,
          ...listaDeDatasIniciaisDosPeriodos,
        ]
        return acumulador
      },
      new Map<string, string[]>()
    )

    return Object.entries(listaDeDatasFinaisPorProjetoId).reduce(
      (acumulador, [projetoId, listaDeDatas]) => {
        const listaDeDatasFinaisDoControlador = [...new Set(listaDeDatas)]
        const [dataFinalMaisAntiga] = listaDeDatasFinaisDoControlador
          .slice()
        acumulador[projetoId] = dataFinalMaisAntiga
        return acumulador
      },
      new Map<string, string>()
    )
  }

  const montarListaDeProjetosComDataFinalParaEdicao = (
    datasIniciaisPorProjetoId: Map<string, string>,
    nomesDeProjetoPorId: Map<string, string>
  ) => {
    return Array.from(nomesDeProjetoPorId.keys()).reduce((acumulador, idProjeto) => {
      const nomeDoProjeto = nomesDeProjetoPorId.get(idProjeto)
      if (nomeDoProjeto) {
        const primeiroDiaDestravado = aplicarTimeZoneNaDataHora(
          datasIniciaisPorProjetoId[idProjeto],
          '00:00:00',
          -3)
        acumulador.push({
          idProjeto: idProjeto,
          nome: nomeDoProjeto,
          primeiroDiaDestravado,
          primeiroDiaDestravadoOriginal: primeiroDiaDestravado,
          editado: false,
        })
      }
      return acumulador
    }, [] as ItemDeProjetoComPeriodoTravado[])
  }

  return [
    ...new Set(
      montarListaDeProjetosComDataFinalParaEdicao(
        mapearListaDeDatasIniciaisPorProjetoId(),
        mapearNomesDeProjetosPorId()
      )
    ),
  ]
}
